import { useEffect } from "react";
import { Navigate } from "react-router-dom";


export default function KYCVerificationManagement() {

  useEffect(() => {
      window.open("https://cockpit.sumsub.com/checkus#/login", "_blank");
  }, []);
  return <Navigate to="/admin/dashboard" /> ;
}
